import { Chain, ChainID } from '@ankr.com/chains-list';

import { ChainPageWidget } from 'modules/chains/components/ChainPageWidget';
import { ChainSelectorsProvider } from 'modules/chains/components/ChainSelectorsProvider';
import { TimeframeProvider } from 'modules/chains/components/TimeframeProvider';

import { Chart } from './components/Chart';
import { Header } from './components/Header';
import { Map } from './components/Map';
import { NetworkUsage } from './components/NetworkUsage';
import { StatsProvider } from './components/StatsProvider';

export interface StatisticsWidgetProps {
  chain: Chain;
}

export const StatisticsWidget = ({ chain }: StatisticsWidgetProps) => {
  return (
    <ChainPageWidget>
      <ChainSelectorsProvider
        chain={chain}
        shouldExpandTestnets={chain.id === ChainID.TAC}
        shouldMergeTacTendermintGroups
        shouldMergeTendermintGroups
        shouldMergeTonGroups
      >
        <TimeframeProvider>
          <Header />
          <StatsProvider>
            <NetworkUsage />
            <Chart />
            <Map />
          </StatsProvider>
        </TimeframeProvider>
      </ChainSelectorsProvider>
    </ChainPageWidget>
  );
};
